import styled from "styled-components";

export const TransactionWrapper = styled.div`
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 2rem 1rem;
  gap: 2rem;

  .cards {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 2rem;

    @media (min-width: ${({ theme }) => theme.screen.tablet}) {
      grid-template-columns: repeat(3, 1fr);
      gap: 2rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
      grid-template-columns: repeat(4, 1fr);
      gap: 2rem;
    }
  }

  .table {
    margin-top: 2rem;
  }

  @media screen and (min-width: ${({ theme }) => theme.screen.smallScreen}) {
  }
`;
